module.exports = __webpack_public_path__ + "static/media/JALAGCA_MENU-normal.c97463dc.png";